import { Price } from '@/services/price';
import queries from './queries';
import { IProductResource, ResourceType, IProduct } from './types';

interface IUpdateParams {
  payload: IProduct;
  componentIds: string[];
  materialIds: string[];
  prices: Price[];
  priceRemoveIds: string[];
}

const updateResource = (type: ResourceType, payload: any) => ({
  data: payload[`${type}s`].map((resource: IProductResource<any>) => ({
    ...resource,
    // reassign resource id
    [`${type}_id`]: resource.resource_id,

    // remove computed/alias fields from query
    resource_id: undefined,
    detail: undefined,
  })),
  on_conflict: {
    constraint: `product_${type}_pkey`,
    update_columns: [
      `${type}_id`,
      'index',
      'name',
      'qty',

      // materials have units
      ...(type === ResourceType.material ? ['unit'] : []),
    ],
  },
});

export default (
  productId: string,
  {
    payload,
    componentIds = [],
    materialIds = [],
    prices = [],
    priceRemoveIds = [],
  }: IUpdateParams,
) => {
  return queries.update({
    // update related records to be removed
    componentIds,
    materialIds,

    // update price/costs (view)
    prices,
    priceRemoveIds,

    // update product
    objects: {
      ...payload,
      id: productId,

      // remove any fields and views from current payload
      // as they cannot be updated directly
      user_id: undefined,
      assets: undefined,
      costs: undefined,
      prices: undefined,

      // update resources
      materials: updateResource(ResourceType.material, payload),
      components: updateResource(ResourceType.component, payload),
    },
  }).then((response: any) => {
    const insertProduct = response.insert_product.returning;
    if (!insertProduct.length) {
      throw {
        code: 'PRODUCT_NOT_UPDATED',
      };
    }
    return insertProduct[0];
  });
};
